import makePartsAndShipmentsApiRequest from '../utils/partsAndShipmentsApi';
import { PartV2 as PartPayload, PartsAddedBy, WorkorderPartsAttribute } from './types.d';
import { error } from '../legacy/flash-messenger';

interface PartsApiResponse {
  metadata: {
    total: number;
    per_page: number;
    pages: number;
    page: number;
  };
  results: PartPayload[];
}

export const createPartApi = async (
  workOrderId: number,
  workOrderUserRole: string,
  companyId: number,
  statusId: number,
  partData: PartPayload,
): Promise<PartPayload | undefined> => {
  const payload = {
    parts: [partData],
  };
  try {
    const response = await makePartsAndShipmentsApiRequest<PartsApiResponse>({
      method: 'POST',
      url: `/parts/v1/${workOrderId}`,
      data: JSON.stringify(payload),
      params: {
        status_id: statusId,
      },
      headers: {
        'X-User-Role': workOrderUserRole,
        'X-Company-Id': companyId,
      },
    });

    return response.results[0];
  } catch (err) {
    error((err as Error).message || 'Failed to create part, please try again later.');
    throw err;
  }
};

export const updatePartApi = async (
  workOrderId: number,
  partId: number,
  workOrderUserRole: string,
  companyId: number,
  statusId: number,
  partData: PartPayload,
): Promise<PartPayload | undefined> => {
  try {
    const response = await makePartsAndShipmentsApiRequest<PartsApiResponse>({
      method: 'PUT',
      url: `/parts/v1/${workOrderId}/${partId}/`,
      data: JSON.stringify(partData),
      params: {
        status_id: statusId,
      },
      headers: {
        'X-User-Role': workOrderUserRole,
        'X-Company-Id': companyId,
      },
    });

    return response.results?.find((part: PartPayload) => part.id === partId);
  } catch (err) {
    error((err as Error).message || 'Failed to update part, please try again later.');
    throw err;
  }
};

export const checkExternalIdUniqueness = async (
  externalId: string,
  companyId: number,
  workOrderUserRole: string,
): Promise<boolean> => {
  try {
    const response = await makePartsAndShipmentsApiRequest<{ exists: boolean }>({
      method: 'GET',
      url: `/parts/v1/exists/external_id/${externalId}`,
      headers: {
        'X-User-Role': workOrderUserRole,
        'X-Company-Id': companyId,
      },
    });
    return !response?.exists;
  } catch (err) {
    error((err as Error).message || 'Failed to validate External ID, please try again later.');
    throw err;
  }
};

export const getWorkorderPartsAttribute = async (
  workOrderId: number,
  workOrderUserRole: string,
  companyId: number,
): Promise<WorkorderPartsAttribute | undefined> => {
  try {
    return await makePartsAndShipmentsApiRequest<WorkorderPartsAttribute>({
      method: 'GET',
      url: `/parts/v1/${workOrderId}/attribute`,
      headers: {
        'X-User-Role': workOrderUserRole,
        'X-Company-Id': companyId,
      },
    });
  } catch (err) {
    return undefined;
  }
};

export const upsertWorkorderPartsAttribute = async (
  workOrderId: number,
  partsAddedBy: PartsAddedBy,
  workOrderUserRole: string,
  companyId: number,
): Promise<WorkorderPartsAttribute | undefined> => {
  try {
    return await makePartsAndShipmentsApiRequest<WorkorderPartsAttribute>({
      method: 'PUT',
      url: `/parts/v1/${workOrderId}/attribute`,
      data: JSON.stringify({ partsAddedBy }),
      headers: {
        'X-User-Role': workOrderUserRole,
        'X-Company-Id': companyId,
      },
    });
  } catch (err) {
    error((err as Error).message || 'Failed to save parts attribute, please try again later.');
    throw err;
  }
};
